import { get, post } from "./Api";

export function ExportBookingSummary({ params, data }) {
  return post({ url: `/api/v1/healthland/export/exportBookingSummary`, params, data });
}

export function ExportBookingDetail({ params, data }) {
  return post({ url: `/api/v1/healthland/export/exportBookingDetail`, params, data });
}